export const chunkHighlightPlugin = {
    id: 'chunkHighlight',
    afterDatasetsDraw(chart) {
        const isActive = chart.options.plugins?.chunkHighlight?.enabled ?? false;
        if (!isActive) return;
        const activeElements = chart.getActiveElements();
        if (!activeElements.length) return;

        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        const xAxis = chart.scales.x;

        const activeIndex = activeElements[0].index;
        const chunkLeft = xAxis.getPixelForValue(activeIndex - 0.5);
        const chunkRight = xAxis.getPixelForValue(activeIndex + 0.5);

        ctx.save();
        ctx.fillStyle =
            chart.options.plugins?.chunkHighlight?.highlightColor ||
            'rgba(0, 0, 0, 0.08)';
        ctx.fillRect(
            chunkLeft,
            chartArea.top,
            chunkRight - chunkLeft,
            chartArea.bottom - chartArea.top
        );
        ctx.restore();
    },
};
